module.exports = __webpack_public_path__ + "img/close.f992c008.svg";